import {StrictMode} from "react";
import ReactDOM from "react-dom";
import App from "./app/App";
import "./app/config/i18n";
import "./toastify";

ReactDOM.render(
    <StrictMode>
        <App/>
    </StrictMode>,
    document.getElementById("root")
);